import { snakeCase, forEach, get, isObject, size, toUpper } from "lodash"

export function generateCoverageQuery(modelsDates) {
  let query = "query($ticker: String, $mic: String, $internalId: String) {"
  forEach(modelsDates, modelDates => {
    query += `${snakeCase(modelDates.id)}: model(id: "${modelDates.id}"){
      security(ticker:$ticker, mic:$mic, internalId: $internalId) {
        descriptors(on:"${modelDates.to}") {
          modelProviderId
        }
      }
    }`
  })
  query += "}"
  return query
}

export function buildModelsCoverageRequest({ modelsDates, resourceType, resourceId, account }) {
  if (!size(modelsDates) || !resourceId || !resourceType) {
    return null
  }

  // security uses a cheap single-date descriptors lookup (GraphQL); every other type
  // (portfolio/swap/etf/index) goes through the no-rollover REST coverage gate.
  if (resourceType === "security") {
    return {
      id: `modelsCoverage-${resourceType}${resourceId}`,
      query: generateCoverageQuery(modelsDates),
      variables: {
        ticker: get(resourceId, "ticker"),
        mic: get(resourceId, "mic"),
        internalId: get(resourceId, "internalId"),
      },
    }
  }

  let resolvedId = resourceId
  if (isObject(resourceId)) {
    resolvedId = resourceType === "etf" ? `${resourceId.ticker}.${resourceId.mic}` : resourceId.ticker
  }
  return {
    id: `modelsCoverage-${resourceType}${resolvedId}`,
    url: `/api/${account}/coverageGate?positionSet=${encodeURIComponent(resolvedId)}`,
    payload: {
      positionSet: { type: toUpper(resourceType), id: resolvedId },
      models: modelsDates,
    },
  }
}
